module.exports = __webpack_public_path__ + "img/operationCapacity5.fcd54317.png";